import React from "react";
import styles from "./projects.module.scss";
import ProjectCard from "@/containers/project-screen/ProjectCard";
import { usePath } from "@/contexts/path/path";
import { Skeleton } from "@aqar-app/react-ui";
import { useQuery } from "@apollo/client";
import { FIND_SEARCH_PROJECTS } from "@/graphql/queries/realestateProjects";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { getMaintainedParam } from "@/lib/apolloClient";

const arrHolder = new Array(10).fill(0);
const ProjectsGrid = () => {
  const { city, filters, page } = usePath();
  const { token, user } = useAuthState();

  const maintainedParam = getMaintainedParam(user?.cooperative);

  const {
    data: { Search: { find: { projects } = {} } = {} } = {},
    loading: loadingProjects,
  } = useQuery(FIND_SEARCH_PROJECTS, {
    variables: {
      bookable_project_filter: {},
      sort: {
        create_time: "desc",
        has_img: "desc",
      },
      size: 20,
      from: ((page || 1) - 1) * 20,
      where: {
        ...filters,
        ...(city ? { city_id: { eq: city?.city_id } } : {}),
        ...maintainedParam,
      },
    },
  });

  if (loadingProjects) {
    return (
      <div className={styles.projectsGrid}>
        {arrHolder.map((_, index) => (
          <Holder key={index} className={styles.holder} />
        ))}
      </div>
    );
  }

  return (
    <div>
      <div className={styles.projectsGrid}>
        {projects?.map((project, i) => (
          <ProjectCard key={project.id} project={project} priority={i < 4} />
        ))}
      </div>
    </div>
  );
};

function Holder() {
  return (
    <div className={styles.holder}>
      <Skeleton />
      <div>
        <Skeleton />
        <Skeleton />
      </div>
      <div>
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
      </div>
      <Skeleton />
    </div>
  );
}

export default ProjectsGrid;
